import { render, staticRenderFns } from "./before-out-import-details.vue?vue&type=template&id=21c460bf&scoped=true"
import script from "./before-out-import-details.vue?vue&type=script&lang=ts"
export * from "./before-out-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c460bf",
  null
  
)

export default component.exports